import { Paper, Table, TableContainer, TableHead, TableCell, TableBody, TableRow, Typography } from "@mui/material";

export default function NewUsers({data}){

    const find = (category, k) => {
        const item = data.find(i => i.category === category) || {};
        return parseFloat(item[k] || 0).toLocaleString();
    }

    return <>

        <Typography variant='h3'>Nouveaux comptes</Typography>

        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Dentaire</TableCell>
                        <TableCell>Kiné</TableCell>
                        <TableCell>Médecine</TableCell>
                        <TableCell>Pharma</TableCell>
                        <TableCell>Santé Mentale</TableCell>
                        <TableCell>Infirmier</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>Nouveaux comptes</TableCell>
                        <TableCell>{find('dentaire', 'users')}</TableCell>
                        <TableCell>{find('kine', 'users')}</TableCell>
                        <TableCell>{find('medecine', 'users')}</TableCell>
                        <TableCell>{find('pharma', 'users')}</TableCell>
                        <TableCell>{find('sante-mentale', 'users')}</TableCell>
                        <TableCell>{find('infirmiere', 'users')}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Inscriptions gratuites</TableCell>
                        <TableCell>{find('dentaire', 'free_enrollments')}</TableCell>
                        <TableCell>{find('kine', 'free_enrollments')}</TableCell>
                        <TableCell>{find('medecine', 'free_enrollments')}</TableCell>
                        <TableCell>{find('pharma', 'free_enrollments')}</TableCell>
                        <TableCell>{find('sante-mentale', 'free_enrollments')}</TableCell>
                        <TableCell>{find('infirmiere', 'free_enrollments')}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Inscriptions payantes</TableCell>
                        <TableCell>{find('dentaire', 'paid_enrollments')}</TableCell>
                        <TableCell>{find('kine', 'paid_enrollments')}</TableCell>
                        <TableCell>{find('medecine', 'paid_enrollments')}</TableCell>
                        <TableCell>{find('pharma', 'paid_enrollments')}</TableCell>
                        <TableCell>{find('sante-mentale', 'paid_enrollments')}</TableCell>
                        <TableCell>{find('infirmiere', 'paid_enrollments')}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>CA</TableCell>
                        <TableCell>{find('dentaire', 'revenue')}</TableCell>
                        <TableCell>{find('kine', 'revenue')}</TableCell>
                        <TableCell>{find('medecine', 'revenue')}</TableCell>
                        <TableCell>{find('pharma', 'revenue')}</TableCell>
                        <TableCell>{find('sante-mentale', 'revenue')}</TableCell>
                        <TableCell>{find('infirmiere', 'revenue')}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>

    </>

}